import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AiSummaryApiService, CaseAiSummaryResponse } from '../../../infrastructure/api/ai-summary-api.service';

@Injectable({ providedIn: 'root' })
export class GetCaseAiSummaryUseCase {
  private readonly _apiService = inject(AiSummaryApiService);

  public execute(caseId: string): Observable<CaseAiSummaryResponse | null> {
    return this._apiService.getSummary(caseId);
  }
}
